import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CustomValidators } from '../../../../../../../shared/custom-validators';
import { BaseForm } from '../../../../../../../shared/product/baseForm';
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../../shared/validators';

@Component({
  selector: 'app-product-step-two',
  templateUrl: './product-step-two.component.html',
  styleUrls: ['./product-step-two.component.scss']
})
export class ProductStepTwoComponent extends BaseForm implements OnInit {
  productTypeId: any;
  productTypeName = "physical product";
  isUpdate: any;
  formValidator: any;
  pendigQuantityDescription: string = 'Quantity booked but not yet paid. Returned if booking expires.'
  paidQuantityDescription: string = 'Quantity paid and confirmed.'
  QuantityDescription: string = '';
  stepForm!: FormGroup;
  controllers = {
    image:
    {
      'fieldName': 'Product Image',
      'fieldNameAr': 'صورة المنتج',
      'fieldType': 'product_image',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        }
      ]

    },
    category:
    {
      'fieldName': 'Category',
      'fieldNameAr': 'الفئة',
      'fieldType': 'category',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        }
      ]
    },
    Product_price:
    {
      'fieldName': 'Product Price',
      'fieldNameAr': 'سعر المنتج',
      'fieldType': 'product_price',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        }
      ]
    },
    pending_quantity: {
      'fieldName': 'Pending Quantity',
      'fieldNameAr': 'الكمية المعلقة',
      'fieldType': 'pending_quantity',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },
    paid_quantity: {
      'fieldName': 'Paid Quantity',
      'fieldNameAr': 'الكمية المدفوعة',
      'fieldType': 'paid_quantity',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },
    quantity: {
      'fieldName': 'original Quantity',
      'fieldNameAr': 'العدد الأصلى',
      'fieldType': 'original Quantity',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },
    available_Dbquantity: {
      'fieldName': 'Quantity',
      'fieldNameAr': 'العدد',
      'fieldType': 'original Quantity',
      'isStaticUI': true,
    },
    available_quantity:
    {
      'fieldName': 'Total Quantity',
      'fieldNameAr': 'العدد الكلي',
      'fieldType': 'available_quantity',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
        {
          validatorFn: CustomValidators.MoreThanOtherField('original Quantity'),
          message: `${this.validationMsg.moreThanOtherField}pending quantity.`,
          messageAr: `${this.validationMsgAr.moreThanOtherField}الكمية المعلقة.`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        }]

    },
    Return_terms:
    {
      'fieldName': 'Return terms',
      'fieldNameAr': 'شروط الاسترجاع',
      'fieldType': 'Return terms',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },
    Delivery_terms:
    {

      'fieldName': 'Delivery terms',
      'fieldNameAr': 'شروط التوصيل',
      'fieldType': 'Delivery terms',
      'isStaticUI': true,
      defaultValue: '',
      validators: []

    },
    is_buyer_info:
    {

      'fieldName': 'Do you want to Add extra Buyer info fields to your product?',
      'fieldNameAr': 'هل تريد ان تأخذ معلومات اضافية من المشتري؟',
      'fieldType': 'Do you want to Add extra Buyer info fields to your product?',
      'isStaticUI': true,
      defaultValue: '',
      validators: []

    },
    maxQuantityPerSale: {
      'fieldName': 'Max Quantity Per Sale',
      'fieldNameAr': 'أقصى كمية لكل عملية بيع',
      'fieldType': 'Max Quantity Per Sale',
      'isStaticUI': true,
      defaultValue: null,
      validators: [
        {
          validatorFn: CustomValidators.lessThanOtherField('Total Quantity'),
          message: `${this.validationMsg.lessThanOtherField}available quantity.`,
          messageAr: `${this.validationMsgAr.lessThanOtherField}الكمية المتوفرة.`
        }
      ]
    }
  }

  constructor() {
    super();
    this.formValidator = new FormValidatorService();
  }

  ngOnInit() {
    this.stepForm = this.formValidator.createForm(Object.values(this.controllers));
    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
    this.stepForm.controls['Total Quantity'].valueChanges.subscribe(value => {
      this.QuantityDescription = "Available Quantity = " + this.stepForm.controls['Quantity'].value
      let maxQuantity = this.stepForm.controls['Max Quantity Per Sale'].value;
      if (+maxQuantity && +maxQuantity > +value) {
        this.stepForm.controls['Max Quantity Per Sale'].setValue(value);
      }
    });

    this.stepForm.controls['Max Quantity Per Sale'].valueChanges.subscribe(value => {
      if (value === '') {
        this.stepForm.controls['Max Quantity Per Sale'].setValue(null);
      }
    });
  }

  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }
}
